export default "/images/b8398e37109ecd4c994c6314ffde0bcc.png";